import React from 'react'
// todo: gms-11333 replace checkbox and divider
import { useTranslation } from 'react-i18next'
import Address from 'core/form/Address'
import { useDispatch, useSelector } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
import { IRootReducerState } from 'state/rootReducer'
import { Alert, Divider, Typography } from '@mui/material'
import Checkbox from '@cbgms/components/form/Material/Checkbox'
import { CountriesDropdownType } from 'core/widgets/CountriesDropdown/enum'

interface IOwnProps {
  form: string
  prefix?: string
  inverted?: boolean
  validate?: boolean
  countries?: CountriesDropdownType
  allFieldsDisabled?: boolean
  visitorAddressCountrySelectionDisabled?: boolean
  isInternalAccount?: boolean
}

type AddressesProps = IOwnProps

const postalFields = ['Address', 'AddressExtra', 'City', 'State', 'HouseNumber', 'HouseNumberAddition', 'PostalCode']

export const Addresses: React.FC<AddressesProps> = props => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    prefix,
    validate,
    form,
    countries = CountriesDropdownType.all,
    allFieldsDisabled,
    visitorAddressCountrySelectionDisabled,
    isInternalAccount
  } = props

  const postalPrefix = `${prefix}Postal`
  const initialShowPostal = useSelector(
    (
      state: IRootReducerState // search for non-empty postal adress field
    ) => !!postalFields.find(fieldKey => !!formValueSelector(form)(state, `${postalPrefix}${fieldKey}`))
  )
  const [showPostal, setShowPostal] = React.useState(initialShowPostal)

  const togglePostal = React.useCallback(() => {
    postalFields.forEach(fieldKey => dispatch(change(form, `${postalPrefix}${fieldKey}`, '')))
    setShowPostal(!showPostal)
  }, [showPostal, setShowPostal])

  return (
    <React.Fragment>
      {isInternalAccount && (
        <Alert severity='info' sx={{ m: 2 }}>
          General, Address and Financial details of internal account can be edited under <a href='/settings/my-shop#general'>My Shop</a>
        </Alert>
      )}
      <Typography variant='h5' gutterBottom>
        {t('global.visit_address')}
      </Typography>

      <Address
        allFieldsDisabled={allFieldsDisabled}
        prefix={`${prefix}Visitor`}
        validate={validate}
        form={form}
        countries={countries}
        countrySelectionDisabled={visitorAddressCountrySelectionDisabled}
      />

      <Divider variant='middle' sx={{ m: 2 }} />

      <Typography variant='h5' gutterBottom>
        {t('global.postal_address')}
      </Typography>

      <Checkbox
        sx={{ ml: 2 }}
        color='default'
        name='ShowPostAddress'
        disabled={allFieldsDisabled}
        label={t('global.showPostal')}
        onChange={togglePostal}
        checked={showPostal}
        data-testid='checkbox-show-postal'
      />
      {showPostal && (
        <div className='mt1'>
          <Address allFieldsDisabled={allFieldsDisabled} prefix={postalPrefix} form={form} countries={countries} />
        </div>
      )}
    </React.Fragment>
  )
}

Addresses.displayName = 'Addresses'

Addresses.defaultProps = {
  prefix: '',
  inverted: false
}

export default Addresses
